import { Grid } from '@mui/material';
import { ReactNode } from 'react';

type CardGridProps = {
  children: ReactNode;
  withTopPadding?: boolean;
};

export const CardGrid = ({ children, withTopPadding = false }: CardGridProps) => (
  <Grid
    container
    sx={{
      gap: '12px',
      display: 'grid',
      gridTemplateColumns: { xs: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)' },
      width: { xs: '100%', md: '100%' },
      paddingTop: withTopPadding ? '12px' : undefined,
    }}
  >
    {children}
  </Grid>
);
